export default {
  methods: {
    fitToContent() {
      this.$refs.iframe.style.height = `${this.$refs.iframe.contentWindow.document.body.scrollHeight}px`;
    },
  },
};
